// extracted by mini-css-extract-plugin
export default {"container":"Router_container__IwZXa"};